<template>

    <v-dialog v-model="show" persistent max-width="80%" width="450px" @keydown="(k) => {k.key == 'Escape' ? show = false : null}">
      <v-card>
        <v-card-title class="headline" :style="{color: '#DC3545'}">
            <v-icon class="mr-3" color="#DC3545">mdi-alert</v-icon>
            {{title}}
        </v-card-title>

        <v-card-text>
          <span v-html="message"></span>
          <!-- {{message}} -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="#DC3545" text @click.stop="show=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
export default {
  name: 'ErrorDialog',
  props: {
      value: Boolean,
      title: String,
      message: String
  },
  data: () => ({
  }),

  computed: {
    show: {
        get () {
            return this.value
        },
        set (value) {
            this.$emit('input', value)
        }
    }
    
  },

  methods: {

  },

  mounted() {
  }

  
};
</script>

<style scoped>
    .headline {
        color: "#D8000C";
    }
</style>

